// extracted by mini-css-extract-plugin
export default {"input":"InviteAgent_input__eb7UZ","form":"InviteAgent_form__2GRIa"};